import { makeAutoObservable, runInAction } from 'mobx'
import { decorate, inject, injectable } from 'inversify'
import { SessionService } from '@evertel/session/SessionService'
import { Api } from '@evertel/api'
import { botMessageActionsNavigationOptions } from '@evertel/web/utils'
import { DisplayThread, RoomStore, ThreadMessagesStore, ThreadStore } from '@evertel/stores'
import { BlueUserStore } from '@evertel/blue-user'


class MessageCTAController {
    isBusy = false

    constructor(
        private session: SessionService,
        private api: Api,
        private threadMessagesStore: ThreadMessagesStore
    ) {
        makeAutoObservable(this)
    }

    getActionLocation = (cta) => {
        if (!cta || !cta.params) return null
        const actionLocation = botMessageActionsNavigationOptions.find(ba => ba.value === cta.params.screen)
        if (!actionLocation.location) return false

        switch (cta.params.screen) {
            default:
                return { location: actionLocation.location, params: actionLocation.params }
        }
    }

    async threadMessageAction(message, actionEvent) {
        if (!message || !actionEvent) return

        this.isBusy = false

        try {
            const result = await this.api.Routes.ThreadMessage.postAction(message.id, {
                action: actionEvent,
                value: undefined
            })

            if (result) {
                this.threadMessagesStore.update((result as any).threadMessage)
            }
        } finally {
            runInAction(() => {
                this.isBusy = false
            })
        }
    }

}

decorate(injectable(), MessageCTAController)
decorate(inject(SessionService), MessageCTAController, 0)
decorate(inject(Api), MessageCTAController, 1)
decorate(inject(ThreadMessagesStore), MessageCTAController, 2)
decorate(inject(ThreadStore), MessageCTAController, 3)
decorate(inject(BlueUserStore), MessageCTAController, 4)
decorate(inject(RoomStore), MessageCTAController, 5)

export { MessageCTAController }
